import { render } from "./unidadMedidaList.vue?vue&type=template&id=1f196394&scoped=true"
import script from "./unidadMedidaList.vue?vue&type=script&lang=js"
export * from "./unidadMedidaList.vue?vue&type=script&lang=js"

import "./unidadMedidaList.vue?vue&type=style&index=0&id=1f196394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f196394"]])

export default __exports__